/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_dnamw_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculate the molecular weight of an oligonucleotide from its sequence. Choose single-stranded DNA, double-stranded DNA or single-stranded RNA; the calculator sums the residue masses using the standard formulas.`)
};

const es_dnamw_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcula el peso molecular de un oligonucleótido a partir de su secuencia. Elige ADN monocatenario, ADN bicatenario o ARN monocatenario; la calculadora suma las masas de los residuos usando las fórmulas estándar.`)
};

const de_dnamw_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berechnen Sie das Molekulargewicht eines Oligonukleotids aus seiner Sequenz. Wählen Sie einzelsträngige DNA, doppelsträngige DNA oder einzelsträngige RNA; der Rechner summiert die Residuenmassen nach den Standardformeln.`)
};

const nl_dnamw_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereken het molecuulgewicht van een oligonucleotide uit de sequentie. Kies enkelstrengs DNA, dubbelstrengs DNA of enkelstrengs RNA; de calculator telt de residumassa's op met de standaardformules.`)
};

const fr_dnamw_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculez la masse moléculaire d'un oligonucléotide à partir de sa séquence. Choisissez ADN simple brin, ADN double brin ou ARN simple brin ; le calculateur additionne les masses de résidus à l'aide des formules standards.`)
};

const it_dnamw_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcola il peso molecolare di un oligonucleotide dalla sua sequenza. Scegli DNA a singolo filamento, DNA a doppio filamento o RNA a singolo filamento; il calcolatore somma le masse dei residui usando le formule standard.`)
};

const pt_br2_dnamw_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcule o peso molecular de um oligonucleotídeo a partir de sua sequência. Escolha DNA de fita simples, DNA de fita dupla ou RNA de fita simples; a calculadora soma as massas dos resíduos usando as fórmulas padrão.`)
};

const pt_dnamw_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcule a massa molecular de um oligonucleótido a partir da sua sequência. Escolha ADN de cadeia simples, ADN de cadeia dupla ou ARN de cadeia simples; a calculadora soma as massas dos resíduos usando as fórmulas padrão.`)
};

const ja_dnamw_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オリゴヌクレオチドの配列から分子量を計算します。一本鎖DNA、二本鎖DNA、一本鎖RNAを選択してください。計算ツールは標準的な式を使って残基質量を合計します。`)
};

const zh_dnamw_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`根据序列计算寡核苷酸的分子量。选择单链 DNA、双链 DNA 或单链 RNA；计算器会使用标准公式将各残基质量相加。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const dnamw_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dnamw_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("dnamw_intro", locale)
	if (locale === "en") return en_dnamw_intro(inputs)
	if (locale === "es") return es_dnamw_intro(inputs)
	if (locale === "de") return de_dnamw_intro(inputs)
	if (locale === "nl") return nl_dnamw_intro(inputs)
	if (locale === "fr") return fr_dnamw_intro(inputs)
	if (locale === "it") return it_dnamw_intro(inputs)
	if (locale === "pt-BR") return pt_br2_dnamw_intro(inputs)
	if (locale === "pt") return pt_dnamw_intro(inputs)
	if (locale === "ja") return ja_dnamw_intro(inputs)
	return zh_dnamw_intro(inputs)
};